module.exports = __webpack_public_path__ + "static/media/bd.f85f48f7.svg";